export { default } from './NotFound'



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/pages/NotFound/index.js